
export type TimeValueUnit = "None" | "Second" | "Month";